var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ic-form__k-03" },
    [
      _c(
        "FormWrapper",
        { attrs: { validator: _vm.$v.form } },
        [
          _c("IcFormContactEmail", {
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactMessage", {
            model: {
              value: _vm.form.message,
              callback: function ($$v) {
                _vm.$set(_vm.form, "message", $$v)
              },
              expression: "form.message",
            },
          }),
          _vm._v(" "),
          _c("IcFormContactFiles", {
            model: {
              value: _vm.form.files,
              callback: function ($$v) {
                _vm.$set(_vm.form, "files", $$v)
              },
              expression: "form.files",
            },
          }),
          _vm._v(" "),
          _c("IcFormAgreements", {
            attrs: {
              text: false,
              header: false,
              modal: true,
              name: "agreement",
              label: _vm.$t("label_agreement_checkbox"),
              content: "form_agreement_k",
            },
            model: {
              value: _vm.form.agreement,
              callback: function ($$v) {
                _vm.$set(_vm.form, "agreement", $$v)
              },
              expression: "form.agreement",
            },
          }),
          _vm._v(" "),
          _c("IcFormButtons", {
            attrs: {
              sending: _vm.isSending,
              error: _vm.isError,
              message: _vm.errorMessage,
            },
            on: { click: _vm.submit },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }